import NdrPanel from "../../components/NdrPanel";

export default function AdminNdr() {
  return <NdrPanel dark />;
}
